// client/src/services/analyticsService.js
export const GA_TRACKING_ID = 'G-DW90LLTGRD';

// Initialize GA - this is a no-op if GA is already initialized
export const initializeGA = () => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('js', new Date());
    window.gtag('config', GA_TRACKING_ID);
  }
};

// Track page views
export const pageview = (path) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('config', GA_TRACKING_ID, {
      page_path: path,
    });
  }
};

// Track events
export const event = ({ action, category, label, value }) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value,
    });
  }
};

// Disable GA - used for cookie consent
export const disableGA = () => {
  if (typeof window !== 'undefined') {
    window['ga-disable-' + GA_TRACKING_ID] = true;
  }
};

// Enable GA - used for cookie consent
export const enableGA = () => {
  if (typeof window !== 'undefined') {
    window['ga-disable-' + GA_TRACKING_ID] = false;
  }
};

// Analytics service using GA for UTM and event tracking
export const analyticsService = {
  // Capture UTM parameters from URL
  captureUtmParams: () => {
    const urlParams = new URLSearchParams(window.location.search);
    const utmParams = {
      utm_source: urlParams.get('utm_source'),
      utm_medium: urlParams.get('utm_medium'),
      utm_campaign: urlParams.get('utm_campaign'),
      utm_term: urlParams.get('utm_term'),
      utm_content: urlParams.get('utm_content')
    };
    
    // Only log UTM parameters if analytics cookies are accepted
    const cookiePreferences = localStorage.getItem('cookiePreferences');
    const preferences = cookiePreferences ? JSON.parse(cookiePreferences) : null;
    
    if (preferences?.analytics && Object.values(utmParams).some(v => v)) {
      console.log('UTM Parameters:', utmParams);
      
      // You can also send these as custom dimensions to GA
      if (typeof window !== 'undefined' && window.gtag) {
        window.gtag('set', {
          'campaign_source': utmParams.utm_source,
          'campaign_medium': utmParams.utm_medium,
          'campaign_name': utmParams.utm_campaign,
          'campaign_term': utmParams.utm_term,
          'campaign_content': utmParams.utm_content
        });
      }
    }
    
    return utmParams;
  },

  // Track event in Google Analytics
  trackEvent: (eventName, parameters = {}) => {
    if (typeof window !== 'undefined' && window.gtag) {
      const cookiePreferences = localStorage.getItem('cookiePreferences');
      const preferences = cookiePreferences ? JSON.parse(cookiePreferences) : null;
      
      if (preferences?.analytics) {
        window.gtag('event', eventName, parameters);
      }
    }
  },

  // Track page view in Google Analytics
  trackPageview: (path) => {
    if (typeof window !== 'undefined' && window.gtag) {
      const cookiePreferences = localStorage.getItem('cookiePreferences');
      const preferences = cookiePreferences ? JSON.parse(cookiePreferences) : null;
      
      if (preferences?.analytics) {
        window.gtag('config', GA_TRACKING_ID, {
          page_path: path
        });
      }
    }
  }
};